import { render, staticRenderFns } from "./PortalContent.vue?vue&type=template&id=7493eb4a&"
import script from "./PortalContent.vue?vue&type=script&lang=js&"
export * from "./PortalContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports